import { FC } from 'react'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FlexColumn, FlexRow } from 'src/components/flex-containers'
import { Colors, Shapes } from 'src/components/theme'
import { Chip } from 'src/v2/components/chip'
import { GenericLoader } from 'src/v2/components/skeleton-loaders'

const HeaderContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[2]}px;
  padding: ${Shapes.spacing[4]}px;
  padding-top: ${Shapes.spacing[6]}px;
  padding-bottom: ${Shapes.spacing[5]}px;
  background-color: ${Colors.bgWhite};
`

type SidebarHeaderContentProps = {
  title?: string
  titleAuxiliary?: React.ReactNode
  subtitle?: React.ReactNode
  type?: string
  children?: React.ReactNode
}

export const SidebarHeaderContent: FC<SidebarHeaderContentProps> = ({
  children,
  subtitle,
  title,
  titleAuxiliary,
  type,
}) => {
  return (
    <HeaderContentContainer>
      <FlexColumn gap={Shapes.spacing[1]}>
        {type && (
          <Chip icon={false} backgroundColor={Colors.neutral100}>
            {type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()}
          </Chip>
        )}
        <FlexRow align="center" gap={Shapes.spacing[2]}>
          <Typography color={Colors.neutral950} variant="header3">
            {title}
          </Typography>
          {titleAuxiliary}
        </FlexRow>
        {subtitle && (
          <FlexRow gap={Shapes.spacing[2]}>
            {typeof subtitle === 'string' ? (
              <Typography color={Colors.neutral500} variant="textmdm">
                {subtitle}
              </Typography>
            ) : (
              subtitle
            )}
          </FlexRow>
        )}
      </FlexColumn>
      {children}
    </HeaderContentContainer>
  )
}

export const HeaderContentLoading: FC = () => {
  return (
    <HeaderContentContainer>
      <FlexColumn gap={Shapes.spacing[1]}>
        <GenericLoader variant="rounded" width={60} height={16} animation="wave" />
        <GenericLoader variant="rounded" color="medium" width={160} height={16} animation="wave" />
        <GenericLoader variant="rounded" width={300} height={16} animation="wave" />
      </FlexColumn>
    </HeaderContentContainer>
  )
}
